<template>
  <div
    class="banner-wrap"
    :class="{ 'bg-center': bgCenter }"
    :style="bannerStyle"
  >
    <div class="banner-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["imgs", "bgCenter"],
  computed: {
    showImg() {
      if (this.imgs && this.imgs.length > 0) {
        return this.imgs[0];
      }
      return "/static/images/index/home_banner.jpg";
    },
    bannerStyle() {
      return {
        "background-image": 'url("' + this.showImg + '")'
      };
    }
  }
};
</script>

<style lang="scss">
@import "../assets/stylesheets/config.scss";
.banner-wrap {
  position: relative;
  width: 100%;
  background-image: url("/static/images/index/home_banner.png");
  height: 754px;
  background-position: right center;
  background-repeat: no-repeat;
  background-size: cover;

  &.bg-center {
    background-position: center;
  }

  .banner-content {
    position: relative;
    height: 100%;
    color: #fff;
    @include wrap_width;

    .slogan {
      width: 100%;

      .slogan-tit {
        font-size: 60px;
        padding-top: 224px;
        font-weight: bold;
      }

      .slogan-desc {
        font-size: 30px;
        line-height: 48px;
        padding-top: 48px;
        color: rgba(255, 255, 255, 0.7);
        font-weight: 600;
      }
    }

    .btn-control {
      padding-top: 110px;

      button {
        width: 174px;
        height: 50px;
        border-radius: 25px;
        border: none;
        outline: none;
        cursor: pointer;
        font-size: 18px;
        color: #fff;
        transition: color 0.2s linear, background-color 0.2s linear,
          border 0.2s linear, box-shadow 0.2s linear;
        background-color: rgba(255, 255, 255, 0.33);

        img {
          position: relative;
          top: 1px;
          left: 10px;
          width: 24px;
          height: 16px;
          transition: 0.4s;
        }
      }

      button:hover {
        background-color: rgba(255, 255, 255, 0.43);

        img {
          left: 14px;
        }
      }
    }
  }
}
@media screen and(max-width: 1680px) {
  .banner-wrap {
    height: 652px;

    .banner-content {
      .slogan {
        .slogan-tit {
          font-size: 52px;
          padding-top: 200px;
        }

        .slogan-desc {
          font-size: 24px;
          padding-top: 30px;
        }
      }

      .btn-control {
        padding-top: 110px;

        button {
          width: 150px;
          height: 44px;
          border-radius: 22px;
          font-size: 16px;
          img {
            left: 10px;
            width: 20px;
            height: 14px;
          }
        }
      }
    }
  }
}
@media screen and(max-width: 1440px) {
  .banner-wrap {
    height: 560px;

    .banner-content {
      .slogan {
        .slogan-tit {
          font-size: 44px;
          padding-top: 160px;
        }

        .slogan-desc {
          font-size: 22px;
          padding-top: 24px;
        }
      }

      .btn-control {
        padding-top: 100px;

        button {
          width: 130px;
          height: 38px;
          border-radius: 20px;
          font-size: 14px;
          img {
            left: 8px;
            width: 18px;
            height: 14px;
          }
        }
      }
    }
  }
}
@media screen and(max-width: 1366px) {
  .banner-wrap {
    height: 530px;

    .banner-content {
      .slogan {
        .slogan-tit {
          font-size: 42px;
          padding-top: 150px;
        }

        .slogan-desc {
          font-size: 20px;
          padding-top: 20px;
        }
      }

      .btn-control {
        padding-top: 90px;

        button {
          width: 124px;
          height: 36px;
          border-radius: 18px;
          font-size: 14px;
          img {
            left: 6px;
            width: 18px;
            height: 12px;
          }
        }
      }
    }
  }
}
@media screen and(max-width: 768px) {
  .banner-wrap {
    height: 30rem;

    .banner-content {
      .slogan {
        .slogan-tit {
          font-size: 2.6rem;
          padding-top: 10rem;
        }

        .slogan-desc {
          font-size: 1.4rem;
          line-height: 2.3rem;
        }
      }

      .btn-control {
        padding-top: 2.5rem;

        button {
          width: 13rem;
          height: 4.4rem;
          background: rgba(255, 255, 255, 0.5);
          border-radius: 2.2rem;
          font-size: 1.4rem;
          font-weight: 600;
          img {
            display: none;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue